import { action, computed, observable } from 'mobx'
import { task } from 'mobx-task'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { Membership } from '@/features/iam/workspaces/Membership'

export class CreateJobConfirmationDialogViewModel {
  readonly modal = new ModalViewModel({ onClose: () => this.reset() })

  @observable
  accessor confirmationInput = ''

  @observable
  accessor membership: Membership | null = null

  constructor(
    private readonly _initializeJobCallback: (
      membership: Membership,
    ) => Promise<void>,
  ) {}

  @computed
  get workspaceName() {
    return this.membership?.workspace?.name ?? ''
  }

  @computed
  get memberName() {
    return this.membership?.member?.displayName ?? ''
  }

  @computed
  get canConfirm() {
    if (!this.membership) {
      return false
    }

    return (
      this.confirmationInput.trim() ===
      (this.membership.workspace.name?.trim() ?? '')
    )
  }

  @action.bound
  setInput(value: string) {
    this.confirmationInput = value
  }

  @action.bound
  open(membership: Membership) {
    if (this.modal.showing) {
      return
    }

    this.membership = membership
    this.confirmationInput = ''
    this.modal.show()
  }

  @action.bound
  reset() {
    this.confirmationInput = ''
    this.membership = null
  }

  confirm = task.resolved(async () => {
    if (!this.membership || !this.canConfirm) {
      return
    }

    try {
      await this._initializeJobCallback(this.membership)
    } catch {
      return
    }
    this.modal.close()
  })
}
